<template>
    <div>
        <!-- ALERT -->
        <div class="alert alert-danger position-fixed w-75 text-center translate-middle-x start-50"
            :class="showAlert ? '' : 'd-none'">
            <div class="row">
                <div class="col">
                    <h4>Accesso negato</h4>
                </div>
                <p v-if="finitiGiurati">Contattare la segreteria studenti.</p>
                <p v-else-if="pleaseLogAgain">
                    all good pls log again.
                    <br><span class="text-decoration-underline">Rinquadrare il QR code.</span>
                </p>
                <p v-else>
                    Il codice di accesso è scaduto o errato.
                    <br><span class="text-decoration-underline">Rinquadrare il QR code.</span>
                </p>
            </div>
        </div>

        <div v-if="showBenvenuto" class="row mt-4">

            <div class="col-12 col-lg-6 border-end">
                <div class="text-center">
                    <h1 class="fw-light">Benvenuto in <span class="fw-bold">ALMA!</span></h1>
                </div>
                <div class="col-6 col-lg-12 mx-auto"><img class="img-fluid"
                        src="../../public/img/Template_Linkedin_Soluta.png"></div>
            </div>

            <div class="col-12 col-lg-6 px-4 pb-4">

                <form>
                    <h1 class="fw-bold">Inserisci i tuoi dati!</h1>

                    <div class="mb-3">
                        <label class="form-label">Nome e Cognome</label>
                        <input v-model="nomeCognome" type="text" id="nome">
                        <span v-if="nomeCognome.length > 0 && !isNameValid" class="text-danger">
                            Per favore inserisci sia il Nome che il Cognome.
                        </span>
                        <span v-if="showerror" class="text-danger">Compilare tutti i campi.</span>

                    </div>
                    <button :disabled="!isNameValid" @click.prevent="showEsamiOrPreRegistrationDone($route.query.key)" :class="{ 'opacity-50': !isNameValid, 'cursor-not-allowed': !isNameValid }">Procedi</button>
                </form>

            </div>
        </div>
        <div class="min-vh-100 d-flex justify-content-center">
            <div class="container align-items-center" style="max-width: 400px;">
                <div class="d-flex flex-column  gap-3">
                    <div v-if="showButtons" class="text-center">
                        <h4 class="mb-4">Per favore continua con la registrazione</h4>

                        <button class="w-100 mb-2" v-on:click.prevent="handleProviderSignIn('google', 'Giurato')">
                            <i class="bi bi-google me-2 text-white"></i> Accedi con Google
                        </button>

                        <button class="w-100 mb-2" v-on:click.prevent="handleProviderSignIn('apple', 'Giurato')">
                            <i class="bi bi-apple me-2 text-white"></i> Accedi con Apple
                        </button>

                        <div v-if="showNoLogin" class="w-100 mb-2">
                            <a href="" style="color: #314361;" @click.prevent="loginWithoutProvider()">Oppure
                                accedi senza </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Custom Confirm Modal -->
        <div v-if="showConfirmModal"
            class="modal-backdrop position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style="background-color: rgba(0,0,0,0.5); z-index: 1050;">
            <div class="bg-white p-4 rounded shadow" style="min-width: 300px; padding: 11px;">
                <h5 class="mb-3">Conferma</h5>
                <p>Sei {{ nomeGiuratoStored }}?</p>
                <div class="d-flex justify-content-end gap-2 mt-3">
                    <button @click="resolveConfirm(false)" class="btn btn-secondary">No</button>
                    <button @click="resolveConfirm(true)" class="btn btn-primary bgAlma">Sì</button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
export default {

    name: 'LoginEsterni',
    components: {},
    data() {
        return {
            nomeCognome: '',
            showerror: false,
            finitiGiurati: false,
            showBenvenuto: false,
            showAlert: false,
            showButtons: false,
            pleaseLogAgain: false,
            showNoLogin: true,
            showConfirmModal: false,
            confirmResolver: null,
            nomeGiuratoStored: ''
        };
    },
    computed: {
        isConnectionReady() {
            return this.$store.getters.isConnectionReady;
        },
        // New validation check
        isNameValid() {
            const trimmed = this.nomeCognome.trim();
            // Checks if there is at least one space between words
            return trimmed.split(/\s+/).length >= 2;
        }
    },
    watch: {
        isConnectionReady: {
            immediate: true,
            handler: 'onConnectionReady'
        }
    },
    async mounted() {
        console.log("LoginEsterni mounted");

        // Initial load
        await this.handleLoginFlow();

        // Safari (bfcache) fix
        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                console.log('Page restored from bfcache');
                this.handleLoginFlow();
            }
        });
    },
    methods: {
        async handleLoginFlow() {
            const tav = this.$route.query.tav;
            const otp = this.$route.query.otp;
            const key = this.$route.query.key;
            console.log('tav: ', tav);
            if (key) {window.OpenReplay.setUserID(key);}
            if (tav) this.$store.commit('SET_TAVOLOGIURATO', tav);
            else console.error("no tav");

            if (otp) {
                console.log('otp: ', otp);
                let resp = await this.$store.dispatch('checkOTP', { otp });
                console.log(resp);

                if (resp === 'ok') {
                    if (this.$store.getters.getQrAndLoginDoneToday) {
                        
                        let userVerified = await this.verifyOrResetUser();
                        if (userVerified) return;
                    } else {
                        console.log("reset pls");
                        // TODO: clear localstorage if needed
                    }

                    this.showButtons = true; // when empty localStorage just continues as usual
                    if (this.showAlert) this.showButtons = false; // in case if we have error hide buttons
                    if (this.showBenvenuto) this.showButtons = false; // in case if we have error hide buttons
                } else {
                    console.error("checkOTP failed");
                    this.showAlert = true;
                    this.showerror = true;
                    this.showButtons = false;
                }
            } else {
                if (this.isConnectionReady) {
                    this.$store.commit('SET_CONNECTION_READY', false);
                    return;
                }

                if (key) {
                    this.showButtons = true;
                    this.showNoLogin = false;
                    if (this.showAlert) this.showButtons = false; // in case if we have error hide buttons
                    if (this.showBenvenuto) this.showButtons = false; // in case if we have error hide buttons
                    return
                }

                console.error("no otp");
                this.showAlert = true;
                this.showerror = true;
                this.showButtons = false;
            }
        },

        async handleProviderSignIn(provider) {
            console.log("handleProviderSignIn() provider: ", provider);
            const payload = {
                provider,
                Status__c: "Giurato",
                callBackPath: "/loginEsterni",
                isCreateAllowed: true,
                SignupSource__c: "Giurato",
                tav: this.$route.query.tav,
                key: this.$route.query.key
            };
            const resp = await this.$store.dispatch('signInWithProvider', payload);
            if (resp.authorizationUrl) {
                window.location.href = resp.authorizationUrl;
            }
        },

        async onConnectionReady(val) {
            if (val) {
                await this.$store.dispatch('loginbyid');
                await this.doLoginGiurato(
                    this.$store.state.connection.userdata,
                    this.$store.state.connection.token,
                    true
                );
            }
        },

        async loginWithoutProvider() {
            const { userdata, token } = await this.$store.dispatch('createAndLoginGiurato');
            await this.doLoginGiurato(userdata, token, false);
        },

        async doLoginGiurato(crypt, token, isProvider) {
            const key = this.$route.query.key;
            const loginResult = await this.$store.dispatch('loginGiurato', { crypt, token });

            if (loginResult) {
                this.$store.commit('SET_QR_AND_LOGIN_DONE', true);
                this.showButtons = false;

                if (this.$route.query.tav) this.$store.commit('SET_TAVOLOGIURATO', this.$route.query.tav);

                const profile = this.$store.state.userprofile;
                if (profile.Nome_Giurato__c) {
                    this.nomeCognome = profile.Nome_Giurato__c;
                    await this.showEsamiOrPreRegistrationDone(key);
                } else if (profile.Name) {
                    if (isProvider) this.nomeCognome = profile.Name;
                    this.showBenvenuto = true;
                }
            } else {
                this.finitiGiurati = true;
                this.showAlert = true;
                this.showButtons = false;
            }
        },

        async showEsamiOrPreRegistrationDone(key) {
            if (this.nomeCognome) {
                await this.updateNameGiurato();
                window.location.href = key ? '/#/preRegisterDone' : '/#/Esami';
            } else {
                this.showBenvenuto = true;
                this.showerror = true;
                this.showButtons = false;
            }
        },

        async updateNameGiurato() {
            this.$store.commit('SET_NOMEGIURATO', this.nomeCognome.toUpperCase().trim());
            const parts = this.nomeCognome.split(' ');
            const acc = {
                Id: this.$store.state.userprofile.Id,
                Nome_Giurato__c: this.nomeCognome.trim(),
                FirstName: parts[0],
                LastName: parts.slice(1).join(' ') || ' '
            };
            await this.$store.dispatch('updateAccount', { account: acc });
        },

        async verifyOrResetUser() {
            
            const confirmed = await this.askUserToConfirmIdentity();
            if (!confirmed) {
                this.$store.commit('CELAR_QR_AND_LOGIN_DONE');
                this.$store.commit('RESET_LOGIN_DATA_ONLY');
                this.showButtons = true;
                return false
            } else {
                await this.doLoginGiurato(
                    this.$store.state.connection.userdata,
                    this.$store.state.connection.token
                );
                return true;
            }
        },
        
        askUserToConfirmIdentity() {
            console.log("askUserToConfirmIdentity");
            
            const nomeGiurato = localStorage.getItem('nomeGiurato');
            if (!nomeGiurato) {
                return false;
            }
            this.nomeGiuratoStored = nomeGiurato;
            return this.customConfirm();
        },

        customConfirm() {
            console.log("customConfirm");
            return new Promise((resolve) => {
                this.showConfirmModal = true;
                this.confirmResolver = resolve;
            });
        },

        resolveConfirm(result) {
            console.log("resolveConfirm");
            this.showConfirmModal = false;
            if (this.confirmResolver) {
                this.confirmResolver(result);
                this.confirmResolver = null;
            }
        },
    }
}
</script>

<style scoped>
button:hover {
    filter: brightness(1.4);
    transition: filter 0.2s ease-in-out;
}
</style>
